// import isWorker from 'utils/common/isWorker'
import { getQuery } from 'utils/common'

const isWorker = false // check if its logger if you want another style for workers log
const LOGGERS = []

const keyStyles = color => `background: ${color}; color: #FFFFFF; padding: 3px 10px; font-weight: bold; border-radius: 10px; font-familly: 'monospace';`
const workerStyles = 'background: #cc00c5; color: #FFFFFF; padding: 3px 10px; font-weight: bold; border-radius: 10px; font-familly: \'monospace\';'

const forceLog = getQuery('log')
if (forceLog) console.log('#### Force log enabled ####')

function createLogger (key = 'Global', color = LOG, enable = true) {
  if (forceLog) enable = true // full logs on query
  const logger = {
    enabled: !!enable,
    key,
    color,
    log (...args) {
      const finalArgs = []

      if (isWorker) {
        finalArgs.push(`%cWorker%c %c${key}`)
        finalArgs.push(workerStyles, ' ')
      } else {
        finalArgs.push(`%c${key}`)
      }

      finalArgs.push(keyStyles(color))

      finalArgs.push(...args)

      if (enable) {
        console.log.apply(console, finalArgs)
      }
    }
  }

  LOGGERS.push(logger)

  return logger.log
}

export function getLogger (key, color, enable = true) {
  for (let i = 0, l = LOGGERS.length; i < l; i++) {
    const LOGGER = LOGGERS[i]
    if (LOGGER.key === key && LOGGER.color === color) {
      return LOGGER.log
    }
  }
  return createLogger(key, color, enable)
}

export const LOG = '#000000'
export const INFO = '#007bff'
export const WARN = '#ffc107'
export const ERROR = '#dc3545'
